export const useApi = () => {
  const apiPrefix = 'jvn'

  const authApi = {
    LOGIN: apiPrefix + '/user/login',
    LOGOUT: apiPrefix + '/user/logout',
    USER: apiPrefix + '/user',
    REFRESH: apiPrefix + '/user/refreshToken',
    VERIFICATION: apiPrefix + '/user/checkUserVerification',
    RESETPASSWORD: apiPrefix + '/user/resetPassword',
    SEND_RESET_PASSWORD_LINK: apiPrefix + '/user/sendPasswordResetLink'
  }
  const adminAuthApi = {
    LOGIN: apiPrefix + '/admin/user/login',
    LOGOUT: apiPrefix + '/admin/user/logout',
    USER: apiPrefix + '/admin/user',
    REFRESH: apiPrefix + '/admin/user/refreshToken',
    VERIFICATION: apiPrefix + '/admin/user/checkUserVerification',
    RESETPASSWORD: apiPrefix + '/admin/user/resetPassword',
    SEND_RESET_PASSWORD_LINK: apiPrefix + '/admin/user/sendPasswordResetLink'
  }
  const searchApi = {
    SEARCH: apiPrefix + '/search/style',
    SEARCH_STYLE: apiPrefix + '/search/style/%s',
    SEARCH_CATEGORY: apiPrefix + '/search/category/%s',
    SEARCH_WP_CATEGORY: apiPrefix + '/search/wpCategory/%s',
    SEARCH_OFFPRICE_CATEGORY: apiPrefix + '/search/offprice/%s',
    SEARCH_OFFPRICE_LOOKUP: apiPrefix + '/search/offprice-Lookup',
    SEARCH_OFFPRICE_LOOKUP_STYLE: apiPrefix + '/search/offprice-lookup/%s',
    SEARCH_CATEGORYLIST: apiPrefix + '/search/categoryList',
    //SEARCH_WP_CATEGORYLIST: apiPrefix + '/search/wpCategoryList',
    SEARCH_WP_CATEGORYLIST: apiPrefix + '/search/wpCategoryNav',
    SEARCH_SizeAndColor: apiPrefix + '/search/sizeAndColor/%s',
    SEARCH_COLORLIST: apiPrefix + '/search/colorList',
    SEARCH_COLOR: apiPrefix + '/search/color/%s',
    SEARCH_COLOR_COLORS: apiPrefix + '/search/color/colors',
    SEARCH_PriceAndColorAndSize: apiPrefix + '/search/priceAndColorAndSize/%s',
    SEARCH_BARCODE: apiPrefix + '/search/barcode/%s'
  }
  const productApi = {
    PRODUCT_LIST: apiPrefix + '/product/list',
    PRODUCT_DETAIL: apiPrefix + '/product/detail'
  }
  const cartApi = {
    CART: apiPrefix + '/cart',
    CART_ADD: apiPrefix + '/cart/add',
    CART_COUNT: apiPrefix + '/cart/count'
  }
  const checkoutApi = {
    CHECKOUT: apiPrefix + '/checkout',
    CHECKOUT_ME: apiPrefix + '/checkout/me'
  }
  const salesOrderApi = {
    SALESORDER_LIST: apiPrefix + '/salesorder/list',
    SALESORDER_DETAIL: apiPrefix + '/salesorder/detail/%s',
    SALESORDER_PRINT: apiPrefix + '/salesorder/print/%s',
    SALESORDER_EMAIL: apiPrefix + '/salesorder/email/%s'
  }
  const n41Api = {
    N41_OPEN_ORDER_LIST: apiPrefix + '/n41/openOrderShipStatus/list',
    N41_OPEN_ORDER_DETAIL: apiPrefix + '/n41/openOrderDetail/%s',
    N41_OPEN_INVOICE_LIST: apiPrefix + '/n41/openInvoice/list',
    N41_OPEN_INVOICE_PRINT: apiPrefix + '/n41/openInvoice/print/%s',
    N41_OPEN_CM_LIST: apiPrefix + '/n41/openCreditMemo/list',
    N41_OPEN_CM_PRINT: apiPrefix + '/n41/openCreditMemo/print/%s'
  }
  const raApi = {
    RA_LIST: apiPrefix + '/ra/list',
    RA_DETAIL: apiPrefix + '/ra/detail/%s',
    RA_CREATE: apiPrefix + '/ra/create',
    RA_REVIEW: apiPrefix + '/ra/review'
  }
  return {
    authApi,
    adminAuthApi,
    searchApi,
    productApi,
    cartApi,
    checkoutApi,
    salesOrderApi,
    raApi,
    n41Api
  }
}
